import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VRow,[_c(VCol,[_c(VCard,{staticStyle:{"height":"calc(100vh - 40%)","overflow":"hidden"}},[_c('div',{ref:"ganttContainer",staticClass:"gantt-container",staticStyle:{"width":"100%","height":"100%","max-height":"100%","overflow":"hidden"}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }